<template>
  <div
    class="vertical-layout h-100"
    :class="[layoutClasses]"
    :data-col="isNavMenuHidden ? '1-column' : null"
  >
    <!-- Navbar - Removida para economizar espaço, funcionalidades movidas para o sidebar -->
    <!-- <b-navbar
      :toggleable="false"
      :variant="navbarBackgroundColor"
      class="header-navbar navbar navbar-shadow align-items-center"
      :class="[navbarTypeClass]"
    >
      <slot
        name="navbar"
        :toggleVerticalMenuActive="toggleVerticalMenuActive"
        :navbarBackgroundColor="navbarBackgroundColor"
        :navbarTypeClass="[...navbarTypeClass, 'header-navbar navbar navbar-shadow align-items-center']"
      >
        <app-navbar-vertical-layout :toggle-vertical-menu-active="toggleVerticalMenuActive" />
      </slot>
    </b-navbar> -->
    <!--/ Navbar -->

    <!-- Mobile Menu Toggle Button (fixed position) -->
    <div 
      v-if="!isNavMenuHidden"
      class="mobile-menu-toggle d-xl-none"
    >
      <button
        class="btn btn-sm btn-primary"
        @click="toggleVerticalMenuActive"
      >
        <feather-icon
          icon="MenuIcon"
          size="20"
        />
      </button>
    </div>
    <!-- /Mobile Menu Toggle Button -->

    <!-- Vertical Nav Menu -->
    <vertical-nav-menu
      v-if="!isNavMenuHidden"
      :is-vertical-menu-active="isVerticalMenuActive"
      :toggle-vertical-menu-active="toggleVerticalMenuActive"
    >
      <template #header="slotProps">
        <slot
          name="vertical-menu-header"
          v-bind="slotProps"
        />
      </template>
    </vertical-nav-menu>
    <!-- /Vertical Nav Menu -->

    <!-- Vertical Nav Menu Overlay -->
    <div
      class="sidenav-overlay"
      :class="overlayClasses"
      @click="isVerticalMenuActive = false"
    />
    <!-- /Vertical Nav Menu Overlay -->

    <!-- Content -->

    <!-- CONTENT TYPE: Left -->
    <transition
      :name="routerTransition"
      mode="out-in"
    >
      <component
        :is="layoutContentRenderer"
        :key="layoutContentRenderer === 'layout-content-renderer-left' ? $route.meta.navActiveLink || $route.name : null"
      >
        <template
          v-for="(index, name) in $scopedSlots"
          v-slot:[name]="data"
        >
          <slot
            :name="name"
            v-bind="data"
          />
        </template>
      </component>
    </transition>
    <!--/ Content -->

    <!-- Footer -->
    <footer
      class="footer footer-light"
      :class="[footerTypeClass]"
    >
      <slot name="footer">
        <app-footer />
      </slot>
    </footer>
    <!-- /Footer -->

    <slot name="customizer" />
  </div>
</template>

<script>
import { onUnmounted } from '@vue/composition-api'
import AppNavbarVerticalLayout from '@core/layouts/components/app-navbar/AppNavbarVerticalLayout.vue'
import AppFooter from '@core/layouts/components/AppFooter.vue'
import useAppConfig from '@core/app-config/useAppConfig'
import { BNavbar } from 'bootstrap-vue'
import LayoutContentRendererDefault from '@core/layouts/components/layout-content-renderer/LayoutContentRendererDefault.vue'
import LayoutContentRendererLeft from '@core/layouts/components/layout-content-renderer/LayoutContentRendererLeft.vue'
import LayoutContentRendererLeftDetached from '@core/layouts/components/layout-content-renderer/LayoutContentRendererLeftDetached.vue'
import VerticalNavMenu from './components/vertical-nav-menu/VerticalNavMenu.vue'
import useVerticalLayout from './useVerticalLayout'
import mixinVerticalLayout from './mixinVerticalLayout'

export default {
  components: {
    // AppBreadcrumb,
    AppNavbarVerticalLayout,
    AppFooter,
    VerticalNavMenu,
    BNavbar,
    LayoutContentRendererLeftDetached,
    LayoutContentRendererLeft,
    LayoutContentRendererDefault,
  },
  mixins: [mixinVerticalLayout],
  computed: {
    layoutContentRenderer() {
      const rendererType = this.$route.meta.contentRenderer
      if (rendererType === 'sidebar-left') return 'layout-content-renderer-left'
      if (rendererType === 'sidebar-left-detached') return 'layout-content-renderer-left-detached'
      return 'layout-content-renderer-default'
    },
  },
  setup() {
    const {
      routerTransition, navbarBackgroundColor, navbarType, footerType, isNavMenuHidden,
    } = useAppConfig()

    const {
      isVerticalMenuActive,
      toggleVerticalMenuActive,
      isVerticalMenuCollapsed,
      layoutClasses,
      overlayClasses,
      resizeHandler,
      navbarTypeClass,
      footerTypeClass,
    } = useVerticalLayout(navbarType, footerType)

    // Resize handler
    resizeHandler()
    window.addEventListener('resize', resizeHandler)
    onUnmounted(() => {
      window.removeEventListener('resize', resizeHandler)
    })

    return {
      isVerticalMenuActive,
      toggleVerticalMenuActive,
      isVerticalMenuCollapsed,
      overlayClasses,
      layoutClasses,
      navbarTypeClass,
      footerTypeClass,

      // App Config
      routerTransition,
      navbarBackgroundColor,
      isNavMenuHidden,
    }
  },
}
</script>

<style lang="scss">
@import "~@core/scss/base/themes/bordered-layout.scss";

// Adicionar margem superior de 5rem ao conteúdo
.vertical-layout {
  .app-content {
    padding-top: 5rem !important;
  }

  // Ajustar conteúdo para ter margem superior
  &.vertical-menu-modern .app-content {
    padding-top: 5rem !important;
  }

  // Garantir que o conteúdo tenha margem superior
  &.content-wrapper {
    padding-top: 5rem !important;
  }
}

// Adicionar margem superior mesmo quando a navbar está escondida
body.vertical-layout.navbar-hidden {
  .app-content {
    padding-top: 5rem !important;
  }
}

// Remover margem superior na tela de chat (CentralAtendimento) e ocupar até o bottom
body.central-atendimento-active {
  .app-content {
    padding: 0 !important;
    margin: 0 !important;
    height: 100vh !important;
    min-height: 100vh !important;
  }
  
  .vertical-layout {
    height: 100vh !important;
    min-height: 100vh !important;
    padding: 0 !important;
    margin: 0 !important;
  }
  
  .vertical-layout .app-content {
    padding: 0 !important;
    margin: 0 !important;
    height: 100vh !important;
    min-height: 100vh !important;
  }
  
  .vertical-layout.vertical-menu-modern .app-content {
    padding: 0 !important;
    margin: 0 !important;
    height: 100vh !important;
    min-height: 100vh !important;
  }
  
  .vertical-layout.content-wrapper {
    padding: 0 !important;
    margin: 0 !important;
    height: 100vh !important;
    min-height: 100vh !important;
  }
  
  // Garantir que o conteúdo ocupe toda a altura
  .content-area-wrapper {
    height: 100% !important;
    min-height: 100vh !important;
    padding: 0 !important;
    margin: 0 !important;
  }
  
  // Remover padding do content-right
  .content-right {
    padding: 0 !important;
    margin: 0 !important;
    height: 100vh !important;
    min-height: 100vh !important;
  }
  
  // Esconder footer na tela de chat
  .footer {
    display: none !important;
  }
  
  // Garantir que o layout vertical ocupe toda a altura
  .vertical-layout {
    height: 100vh !important;
    min-height: 100vh !important;
    max-height: 100vh !important;
  }
  
  // Adicionar margem à esquerda igual à largura da sidebar
  // Sidebar expandida: 260px
  // Sidebar colapsada: 80px
  .content-wrapper {
    padding-left: 0 !important;
    padding-right: 0 !important;
    margin-left: 3rem !important; // Largura da sidebar expandida
    margin-right: 0 !important;
    transition: margin-left 0.3s ease;
  }
  
  .content-right {
    margin-left: 15.5rem !important; // Largura da sidebar expandida
    transition: margin-left 0.3s ease;
  }
  
  // Quando a sidebar está colapsada (menu-collapsed)
  .vertical-layout.menu-collapsed .content-wrapper,
  .vertical-layout.menu-collapsed .content-right {
    margin-left: 2.7rem !important; // Largura da sidebar colapsada
  }
  
  // Quando a sidebar está escondida (mobile - data-col="1-column")
  .vertical-layout[data-col="1-column"] .content-wrapper,
  .vertical-layout[data-col="1-column"] .content-right {
    margin-left: 0 !important;
  }
  
  // Mobile: remover margem à esquerda
  @media (max-width: 1199.98px) {
    .content-wrapper,
    .content-right {
      margin-left: 0 !important;
    }
  }
  
  .content-area-wrapper {
    padding-left: 0 !important;
    padding-right: 0 !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
}

// Botão de menu mobile
.mobile-menu-toggle {
  position: fixed;
  top: 1rem;
  left: 1rem;
  z-index: 1000;
  
  .btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 42px;
    height: 42px;
    border-radius: 8px;
    padding: 0;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    
    &:hover {
      transform: scale(1.05);
      box-shadow: 0 4px 12px rgba(115, 103, 240, 0.4);
    }
    
    &:active {
      transform: scale(0.95);
    }
  }
}

// Ajuste para mobile - manter o toggler acessível
@media (max-width: 1199.98px) {
  .vertical-layout {
    // Adicionar um pequeno padding apenas em mobile para acessibilidade
    padding-top: 0;
  }
  
  // Ajustar posição do conteúdo quando o menu mobile está visível
  .app-content {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }
}

// Esconder o botão mobile quando o menu está aberto
.vertical-layout.menu-open .mobile-menu-toggle {
  display: none;
}
</style>